var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid mt-4"},[_c('div',[_c('h4',[_vm._v("Logged out")]),_vm._v(" "),_c('span',[_vm._v("You may close this window or sign in again "),_c('b-link',{attrs:{"to":"/"}},[_vm._v("here")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }